<template>
  <div class="main-page">
  	<header>
		  	<div class="header">
		  		<h1>
			    	<a href="javascript:;"></a>
			   </h1>
		  	</div>
		</header>
    <FilterBox :type="3" />
    <List :total="totalPage" :items="list" :last="isLastPage" />
    <footerWrap :count="count" v-show="showFooter" @auth="auth" @openModal="openModal"></footerWrap>
    <InnerLoading v-show="loading" />
    <PageLoading :show="authloading" />
    <modal v-show="isModalVisible"
	      :backdrop="true"
	      class="modal-login"
	      @close="closeModal">
    	<template slot="header">
	        <h2>用户协议</h2>
	      </template>
	      <template slot="body">
	      	<div>
	      		<h3>欢迎使用“我有货”供应链管理系统！（以下简称“我有货”）</h3>
          <p>“我有货”所有权由上海郅熙电子商务有限公司所有。本协议是我有货用户与我有货所有者上海郅熙电子商务有限公司（以下简称为“公司”）之间就“我有货”服务等相关事宜所订立的契约。为了保障用户的权益，请在注册“我有货”前，详细阅读本协议。一旦您注册为用户即表示您已接受了以下所述的条款和条件。</p>
          <p>当您勾选“用户协议”并开始启用本系统时，即表示您已同意接受“我有货”的相关服务协议约束，包括但不限于本协议、“我有货”现有的、及时更新的或新发布的用户协议条款和隐私权政策以及其他各项规则、制度等等。</p>
          <p>“我有货”有权随时修改和（或）补充前述条款和条件，并只需在“我有货”上正式公示或者通知，而无需征得您的事先同意。修改后的条款于公示或者通知即时生效。在“我有货”修改相关协议条款后，您继续使用“我有货”电子商务平台应被视作您已接受了修改后的条款。除非得到“我有货”的正式书面授权，任何人不得修改本协议。所有条款标题仅为方便参阅而设置，并不以任何方式界定、限制、解释或描述该条款的范围或限度。本公司及“我有货”未就用户或其他人员的某项违约行为采取行动，并不表明本公司及本网站撤回就任何继后或类似的违约事件采取行动的权利。
            在本协议中，被许可“我有货”用户均简称为“我有货”用户”或“您”。</p>
          <h4>第一条、“我有货”注册与使用</h4>
          <p>1.1
            在“我有货”上注册或者交易许可仅向能够根据相关法律订立具有法律约束力的合约的自然人及企业提供。因此，“我有货”用户应确认本人已满十八周岁，且系完全民事行为能力人。在“我有货”上注册并同意本协议条款，将视为“我有货”的用户。在注册用户通过供应商认证的，此用户将做为“我有货”的主账号被授权代表本供应商企业进行交易操作，交易操作行为根据用户申请及“我有货”的审核确定其在“我有货”的相应角色。</p>
          <p>1.2 “我有货”用户须同时凭用户名、密码及系统验证码进行登录。对于通过其他手段登录、使用所造成的后果，“我有货”将不承担任何责任。若因此造成不良影响或者损失，“我有货”将保留追究当事人法律责任的权力。</p>
          <p>1.3
            在“我有货”注册时，“我有货”用户明确表示通过其用户名和密码进行的任何操作（交易等）均应被视为“我有货”用户本人行为（做为本企业的主账号，“我有货”将视同授权其代表企业的行为），其法律后果由“我有货”用户本人或所授权代表的企业承担。“我有货”用户应妥善保管用户名和密码，并对其使用及其遗失自行承担相应责任。“我有货”用户承诺，如其用户名和密码遭到未获授权的使用，或者发生其他任何安全问题时，将立即通知“我有货”。“我有货”用户在此同意并确认，“我有货”对因上述情形产生的遗失或损害不负责任。</p>
          <h4>第二条、用户实名查证</h4>
          <p>2.1
            供货商及采购商获得“我有货”使用许可前，必须通过供应商认证，即由“我有货”查证有关该用户在申请取得网站使用许可所提供的信息。“我有货”有权了解其他信息的真实性、准确性、合理性，“我有货”用户应认真履行配合义务，否则，“我有货”有权拒绝提供网站使用许可。“我有货”用户应始终保持其主体身份（主账号）真实、合法、有效。一旦用户信息有任何变更，应及时通知“我有货”，“我有货”用户将及时将更新有效信息提交给“我有货”授权工作人员。“我有货”用户同意为自身未及时通知或更新相关信息承担全部责任，如因此而给其他方（包括其关联公司、合作伙伴、代理人、职员等）造成损失的，“我有货”用户同意赔偿其全部损失（包括律师费等维权费用）。</p>
          <p>2.2 用户认证通过审核后，“我有货”将通过用户在“我有货”注册时提供的手机号码发出短信通知。对于“我有货”用户主账号的手机号码变更，由主账号或者其授权机构向“我有货”提出变更申请，经“我有货”审核后方可变更。</p>
          <h4>第三条、“我有货”用户义务</h4>
          <p>3.1 自觉遵守“我有货”注册及交易规则 ，若出现违反相关规则相关规则及制度者，将承担全部责任：</p>
          <p>3.1.1 注册用户所提供的信息必须真实可靠；</p>
          <p>3.1.2 “我有货”用户必须保管好自身账号及密码，若因“我有货”用户自身泄密账户、密码，并由此造成的一切损失，都由用户负责。</p>
          <p>3.1.3 在“我有货”现货晒场上所挂牌的信息必须真实可靠。</p>
          <p>3.1.4 为保证交易安全，涉及资金问题，所有交易款项根据合同约定暂时由银行冻结出金，经产品或服务采购商确认后转给收款方。</p>
          <p>3.1.5 不得利用“我有货”进行非法交易或其他损害“我有货”或他人利益的任何行为。</p>
          <h4>第四条、“我有货”权利</h4>
          <p>4.1 “我有货”将按照本协议的规定许可“我有货”用户使用本网站进行交易。</p>
          <p>4.2 “我有货”有权保存“我有货”用户的信息，并为了“我有货”用户的利益用之与其联络。</p>
          <p>4.3 “我有货”有权随时删除含有任何违反法律、法规、软件使用许可协议、各项规则的信息或链接，包括“我有货”对此有合理怀疑的信息。</p>
          <p>4.4 “我有货”有权对“我有货”用户使用网站的行为进行监督。且“我有货”保留在用户违反协议时无需给予通知终止“我有货”用户使用平台权力。</p>
          <p>4.5
            上述保证将替代所有其它保证。在适用法律允许的最大范围内，特此替代所有其它保证、条件和声明，无论是明示的、默示的、口头的、法定的和其它方式，并且无论是依据本协议或其它协议而产生的，包括但不限于：不侵权、适合市场销售及适用于某个特定用途的默示保证。</p>
          <p>4.6
            “我有货”将在其网络系统内建立合理的安全体系，包括身份识别体系、内部安全防范体系，以使“我有货”数据完整，并且保密。但“我有货”用户了解并同意技术手段在不断更新，无法杜绝全部的非安全因素，但“我有货”会及时更新安全体系，妥善维护网络及相关数据。</p>
          <p>4.7 “我有货”用户在网站上所注册、交易的数据由“我有货”保管，并根据需要进行分析，为网站提供相关许可范围内的服务。</p>
          <h4>第五条、“我有货”义务</h4>
          <p>5.1 “我有货”保证对所有用户所有信息进行保密，包括个人信息、货物信息及交易信息等。</p>
          <p>5.2 “我有货”保证其提供网站的合法性。</p>
          <p>5.3 “我有货”保证其网站上交易货物的信息真实性。</p>
          <h4>第六条、诚信原则 </h4>
          <p>6.1
            “我有货”用户承诺，其将恪守诚信原则，“我有货”用户有下列情形之一的，其完全同意“我有货”有权立即单方给与包括但不限于警告、公示、限权或终止服务等不同程度的处罚：被终止服务的用户将在“我有货”网站上进行通告，“我有货”无需承担任何违约责任，且保留追究其责任的权力。</p>
          <p>6.1.1 涉嫌利用软件实施欺诈或其他违法行为的（“我有货”有权单方对此做出相关认定）；</p>
          <p>6.1.2 被任何第三方投诉，称其（含其发布信息中所提及的相关公司，下同）有违约行为，且未能在“我有货”要求的合理期限内提供证据，或虽在上述期限内提供了证据，但未能充分证明其不存在上述行为的；</p>
          <p>6.1.3 未经“我有货”书面同意，擅自将其帐号和密码转让或泄露给他人的，或售卖或要约售卖其通过“我有货”获得的相关商业信息的；</p>
          <p>6.1.4 利用软件或计算机病毒或者相关木马程序等手段，非法窃取、删除、修改或增加“我有货”网站或“我有货”网站其他用户的任何信息，或以其他任何方式危害“我有货”网站的正常运行的；</p>
          <p>6.1.5 存在“我有货”认定的其他不诚信行为的，或违反其他约定或网站规则的。</p>
          <h4>第七条、终止</h4>
          <p>7.1 “我有货”有权在下列情形下拒绝用户的交易或终止本协议，而无需承担任何责任：</p>
          <p>7.1.1 用户违反了本协议或用户服务协议的任一条款，且自“我有货”通知其纠正后仍未纠正的；</p>
          <p>7.1.2 “我有货”无法确认用户提供的注册信息或银行卡信息的真实性；</p>
          <p>7.1.3 发现用户窃取“我有货”平台任何信息，用其提供给同行业，或其他不正当用途；</p>
          <p>7.2 如协议一方，除为重组或兼并的目的外，通过决议或由法院判令解散，则接收方或指定的债权人代表有权经通知后终止本协议。</p>
          <p>7.3
            在协议期内，在“我有货”用户被第三方多次投诉等合理情形下，为避免“我有货”用户及“我有货”的损失，“我有货”有权以短信或其他书面形式通知“我有货”用户并解除本合同，本合同自通知到达“我有货”用户处时终止。必要时，将终止用户账号以及用户使用“我有货”平台的相应权力。</p>
          <h4>第八条、不可抗力</h4>
          <p>8.1 由于黑客攻击或政府管制或网络通讯瘫痪等对其发生和后果不能预见的事件，双方均确认此属不可抗力；双方应按照不可抗力对影响履行本协议的程度，协商决定是否解除本协议、免除履行本协议的部分义务，或者延期履行本协议。</p>
          <p>8.2 对于因“我有货”合理控制范围以外的原因，包括但不限于自然灾害、罢工或骚乱、暴动、战争行为、政府行为、通讯或其他设施故障或严重伤亡事故等等，而致使“我有货”延迟或未能履约的，“我有货”不对用户承担任何责任。</p>
          <h4>第九条、法律及争议解决</h4>
          <p>9.1 本协议适用中华人民共和国法律。如遇本协议有关的某一特定事项缺乏明确法律规定，则应参照通用国际、国内商业惯例和（或）行业惯例。</p>
          <p>9.2 因双方就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，任何一方均有权向“我有货”所在地人民法院起诉。</p>
          <h4>第十条、知识产权</h4>
          <p>10.1 “我有货”拥有本协议所规定的著作权、商标权、专利权、专利申请权、专有技术、商业秘密以及其他相关的知识产权，包括与该平台有关的各种文档资料，
            如服务内容包括：文字、软件、声音、图片、录像、图表、广告中的全部内容，资讯相关全部信息；电子邮件的全部内容，为用户提供的其他信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护，其它本协议中未经提及的权利也由“我有货”保留。</p>
          <p>10.2 未经“我有货”事先书面同意，“我有货”用户不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何第三方实施、利用、转让上述知识产权。</p>
          <h4>第十一条、协议权利义务的转让</h4>
          <p>除非取得“我有货”事先书面同意，“我有货”用户不得将其在本协议项下的权利与义务转让给任何第三方。</p>
          <h4>第十二条、委托扣款协议</h4>
          <p>“我有货”注册认证用户以经销商身份使用个人银行卡采购默认接受委托扣款协议，现授权人郑重声明已仔细阅知、理解下述各项规定并同意遵守：</p>
          <p>12.1 授权人同意被授权人在合同约定的限期内，委托银行或第三方支付机构从本授权书指定的账户内以约定的资费标准划付到期应付的费用。</p>
          <p>12.2 授权人在指定账户中必须留有足够余额，否则因账户余额不足或不可归责于被授权人委托方的任何事由，导致无法及时扣款或扣款错误、失败，责任由授权人自行承担。</p>
          <p>12.3 本授权书在授权人使用银行系统或者第三方代收通道支付金额时，自动生效。</p>
          <p>12.4 授权人保证本授权书的真实性、合法性、有效性，被授权人依据本授权书进行的委托扣款操作引起的一切法律纠纷或风险，由授权人独立承担或解决。 </p>
          <h4>第十三条、其他</h4>
          <p>13.1 本协议构成“我有货”用户和“我有货”间就使用网站的完整的协议 ，并取代双方就有关本协议所载任何事项于先前以口头及书面达成的共识。</p>
          <p>13.2 如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部分则仍具有法律效力。</p>
          <p>13.3 本协议的标题仅为方便阅读所设，非对条款的定义、限制、解释或描述其范围或界限。</p>
          <p>13.4 “我有货”于“我有货”用户过失或违约时放弃本协议规定的权利的，不得视为其对“我有货”用户的其他或以后同类之过失或违约行为弃权。</p>
          <p>13.5 “我有货”有权随时根据中华人民共和国有关法律、法规的变化、互联网的发展以及公司经营状况和经营策略的调整等修改本协议。“我有货”用户要继续使用网站就有必要对最新的《“我有货”协议条款》
            进行仔细阅读和确认。当发生有关争议时，以最新的协议为准。</p>
	      	</div>
	      </template>
	      <template slot="footer">
	      	<a href="javascript:;" class="btn btn-primary"
            @click="closeModal" style="margin: 0 auto;">我知道了</a>
	      </template>
    </modal>
  </div>
</template>

<script>
import Header from "./../components/header.vue";
import FilterBox from "./../components/filter.vue";
import List from "./../components/receive-offer/list";
import footerWrap from "./../components/receive-offer/footer-wrap.vue";
import InnerLoading from "./../components/innerLoading";
import PageLoading from "./../components/pageLoading";
import modal from "./../components/modal.vue";
export default {
  data() {
    return {
      loading: false,
      authloading: false,
      mobile: localStorage.getItem('OfferProductMobile'),
      page: 1,
      rowsPerPage: 20,
      totalCount: 0,
      totalPage: 1,
      list: [],
      isLastPage: false,
      authId: "",
			authToken: "",
			hasAuth: false,
			showFooter:false,
			count:0,
			needAuth:false,
			isModalVisible:false,
			iframe: this.$route.query.iframe ? this.$route.query.iframe : "",
    };
  },
  components: {
    Header,
    FilterBox,
    List,
    InnerLoading,
    PageLoading,
    footerWrap,
    modal
  },
  methods: {
  	openModal(){
  		this.isModalVisible = true;
  	},
  	closeModal(){
  		this.isModalVisible = false;
  	},
    getList() {
      if(this.loading){
        return;
      }
      if (!this.mobile) {
        this.$toasted.show(`没有手机号数据，请重新获取链接`, {
          theme: "primary",
          position: "top-center",
          className: "danger",
          duration: 9999999
        });
        return;
      }
      if (this.page > this.totalPage) {
        this.isLastPage = true;
        return;
      }
      this.loading = true;
      this.$apiCall(
        "api.OfferProduct.findsByDistributor",
        {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          mobile: this.mobile
        },
        r => {
          this.loading = false;
          if (r.data.ErrorCode == "9999") {
            r.data.Data.Results.forEach(item => {
              this.list.push(item);
            });
            this.totalCount = r.data.Data.Pagination.totalCount;
            this.totalPage = r.data.Data.Pagination.totalPage;
            this.authId = r.data.Data.Results[0].authId;
						this.authToken = r.data.Data.Results[0].authToken;
						this.hasAuth = r.data.Data.Results[0].hasAuth;
						this.count = r.data.Data.Results[0].count;
						this.needAuth = r.data.Data.Results[0].needAuth;
						if(!this.hasAuth && this.needAuth && !this.iframe){
							this.showFooter = true;
						}
            this.page++;
            setTimeout(() => {
              this.scrollGetList();
            }, 200);
          }
        }
      );
    },
    scrollGetList() {
      let scrollT =
        document.documentElement.scrollTop || document.body.scrollTop;
	      if (scrollT + window.innerHeight >= document.body.offsetHeight - 300) {
					if(!this.hasAuth && this.needAuth && !this.iframe){
						return;
					}
					this.getList();
	      }
    },
    auth(){
    	this.authloading = true;
      this.$apiCall(
        "api.OfferProduct.authorize",
        {
         	authId:this.authId,
					authToken:this.authToken,
        },
        r => {
          this.authloading = false;
          if (r.data.ErrorCode == "9999") {
						this.hasAuth = r.data.Data.Results;
						this.showFooter = false;
						this.$toasted.show(
		            `<i class="iconfont icon-warning"></i> 授权成功`,
		            {
		              theme: "primary",
		              position: "top-center",
		              className: "success",
		              duration: 3000
		            }
		        );
            setTimeout(() => {
              this.scrollGetList();
            }, 200);
          }else{
          	this.$toasted.show(
		            `<i class="iconfont icon-warning"></i> 授权失败,请重新授权`,
		            {
		              theme: "primary",
		              position: "top-center",
		              className: "success",
		              duration: 3000
		            }
		        );
          }
        }
      );
    },
  },
  mounted() {
    window.addEventListener("scroll", e => {
      this.scrollGetList();
    });
    this.getList();
  }
};
</script>
<style>
	.modal-body h3 {
    font-size: 18px;
    font-weight: normal;
    line-height: 26px;
    margin-bottom: 20px;
    margin-top: 0;
    color: #1d2939;
}
#modalUserAgreement .modal-body p {
    color: #666;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 10px;
}
#modalUserAgreement .modal-body h4 {
    margin-bottom: 15px;
    margin-top: 0;
    color: #1d2939;
    font-size: 16px;
}
</style>
